import {useMemo} from 'react';
import {FootTrafficItem} from '@/map/@types/foot-traffic';
import {MAP_LAYER_Z_INDEX} from '@/map/constants';
import {Polygon} from '@/map/modules';
import {
  flattenPolygonToNaverCoords, getFootTrafficTileColor, getMobileFootTrafficTileColor
} from '@/map/utils';

interface IProps {
  map: naver.maps.Map;
  item: FootTrafficItem;
  isMobile?: boolean;
}

export const FootTrafficTile = ({map, item, isMobile}: IProps) => {
  const paths = useMemo<naver.maps.Coord[][] | undefined>(() => {
    if (!item || !item.tilePolygon || !item.tilePolygon.coordinates) {
      return;
    }

    return [flattenPolygonToNaverCoords(item.tilePolygon.coordinates)];
  }, [item]);

  if (!item || !paths?.length) {
    return null;
  }

  const colors = isMobile
    ? getMobileFootTrafficTileColor(item.topPercent)
    : getFootTrafficTileColor(item.topPercent);

  return (
    <Polygon
      map={map}
      paths={paths}
      clickable={false}
      strokeWeight={0}
      zIndex={MAP_LAYER_Z_INDEX.DATA_TILE}
      {...colors}
    />
  );
};
